import { render, staticRenderFns } from "./PatrolPanel.vue?vue&type=template&id=fb5784d2&"
import script from "./PatrolPanel.vue?vue&type=script&lang=js&"
export * from "./PatrolPanel.vue?vue&type=script&lang=js&"
import style0 from "./PatrolPanel.vue?vue&type=style&index=0&id=fb5784d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports